import {
  isUnlimitedOnlyEligibleUser,
  paywallVariantOf,
} from "MVVM/State/unlimitedOnlyPaywall";
import { useIsInternalAccount } from "MVVM/Hooks/useIsInternalAccount";
import { useUser } from "MVVM/Hooks/useUser";

/**
 * Unlimited-only paywall (ALL-1929..1933): FREE accounts that have never held
 * a subscription see a single Unlimited card on every upgrade surface instead
 * of the tier grid, and no trial offer. Everyone who has ever subscribed
 * keeps the full grid and the trial.
 *
 * Internal accounts have all held tiers, so while on FREE they get the
 * collapsed grid too, for QA. Synchronous and derived from the hydrated user,
 * so every gate (grids, trial CTAs) can read it on any render; before GET_ME
 * lands it is false (full grid), matching PricingCards' fail-closed rule.
 * REACT_APP_UNLIMITED_ONLY_KILL restores the grid everywhere.
 */
export const useUnlimitedOnlyPaywall = () => {
  const { allstarUser } = useUser();
  const isInternal = useIsInternalAccount();
  const user = allstarUser?.user;
  const variant = paywallVariantOf(
    isUnlimitedOnlyEligibleUser(user) ||
      (isInternal && user?.userGroup?.type === "FREE"),
  );
  return { unlimitedOnly: variant === "unlimited_only", variant };
};
